export default {
  urls: {
    privacy: 'https://www.onecharthealth.com/privacy',
    terms: 'https://www.onecharthealth.com/terms-of-use'
  }
}



// WEBPACK FOOTER //
// ./src/core/consts.js